module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid29_980x869.2403eba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid29_980x869.jpg
// module id = DgQF
// module chunks = 0